package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull
import kotlinx.coroutines.launch
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsDraggedAsState
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset
import songwritersnotebook.app.components.VersionHistorySheet


@Composable
fun EditorBottomBar(
    isChordPanelExpanded: Boolean,
    onShowChords: () -> Unit,
    onAddSection: () -> Unit,
    editorViewModel: EditorViewModel,
    isViewer: Boolean
) {
    val currentStep by TutorialManager.currentStep.collectAsState()
    
    BottomAppBar(
        containerColor = MaterialTheme.colorScheme.surface,
        contentPadding = PaddingValues(horizontal = 12.dp),
    ) {
        Button(
            onClick = onAddSection,
            contentPadding = PaddingValues(horizontal = 64.dp),
            modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_ADD_SECTION),
            enabled = !isViewer
        ) {
            Icon(Icons.Default.Add, contentDescription = "Add Section", modifier = Modifier.size(18.dp))
            Spacer(modifier = Modifier.width(12.dp))
            Text("Add Section", fontSize = 14.sp)
        }
        
        val isListening = editorViewModel.uiState.collectAsStateWithLifecycle().value.isHarmonyListening
        val infiniteTransition = rememberInfiniteTransition()
        val offset by infiniteTransition.animateFloat(
            initialValue = 0f,
            targetValue = 1000f,
            animationSpec = infiniteRepeatable(
                animation = tween(1500, easing = LinearEasing),
                repeatMode = RepeatMode.Restart
            )
        )
        val iconBrush = if (isListening) {
            Brush.linearGradient(
                colors = listOf(Color(0xFF4285F4), Color(0xFF9B72CB), Color(0xFFD96570), Color(0xFF4285F4)),
                start = Offset(offset - 500f, offset - 500f),
                end = Offset(offset, offset)
            )
        } else null

        val micPermissionLauncher = rememberMicPermissionLauncher(
            onGranted = { editorViewModel.onAiAssistantHold() },
            onDenied = { }
        )

        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .size(48.dp)
                .clip(CircleShape)
                .background(if (isListening) Color.White.copy(alpha = 0.2f) else Color.Transparent)
                .pointerInput(currentStep, isViewer) {
                    if (isViewer) return@pointerInput
                    awaitEachGesture {
                        val down = awaitFirstDown()
                        
                        // Wait to see if it's a hold or a tap
                        val holdAction = withTimeoutOrNull(300) {
                            waitForUpOrCancellation()
                        }

                        if (holdAction == null) {
                            // It's a HOLD
                            val currentUiState = editorViewModel.uiState.value
                            val totalCredits = currentUiState.userProfile?.totalAiCredits ?: 0
                            if (totalCredits <= 0) {
                                editorViewModel.onAiLimitDialogDismiss() // ensure state clean
                                editorViewModel.openAiAssistant() // This will trigger the sheet, which might not be what we want if we want to show dialog instead.
                                // Actually, the requirement is: "shown the same ai credit purchase popup"
                                editorViewModel.triggerAiLimitDialog()
                            }
                            
                            micPermissionLauncher() // Starts onAiAssistantHold
                            
                            // Now wait for the eventual release
                            waitForUpOrCancellation()
                            editorViewModel.onAiAssistantRelease()
                        } else {
                            // It's a TAP
                            if (currentStep == TutorialStep.EDITOR_AI_OPEN) TutorialManager.nextStep()
                            editorViewModel.onAiAssistantClicked()
                        }
                    }
                }
                .tutorialTarget(TutorialStep.EDITOR_AI_OPEN)
        ) {
            if (isListening && iconBrush != null) {
                Icon(
                    Icons.Default.AutoAwesome, 
                    contentDescription = "AI Assistant",
                    modifier = Modifier.size(28.dp).graphicsLayer(alpha = 0.99f).drawWithContent {
                        drawContent()
                        drawRect(iconBrush, blendMode = BlendMode.SrcIn)
                    }
                )
            } else {
                Icon(
                    Icons.Default.AutoAwesome, 
                    contentDescription = "AI Assistant",
                    modifier = Modifier.size(28.dp),
                    tint = Color.White
                )
            }
        }
        
        IconButton(
            onClick = { 
                if (currentStep == TutorialStep.EDITOR_WORD_FINDER_OPEN) {
                    TutorialManager.nextStep()
                }
                editorViewModel.openWordFinderPopup() 
            },
            modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_WORD_FINDER_OPEN)
        ) {
            Icon(Icons.AutoMirrored.Filled.MenuBook, contentDescription = "Word Finder")
        }
        IconButton(
            onClick = onShowChords,
            colors = if (isChordPanelExpanded) IconButtonDefaults.iconButtonColors(
                containerColor = MaterialTheme.colorScheme.primary.copy(alpha = 0.2f),
                contentColor = MaterialTheme.colorScheme.primary
            ) else IconButtonDefaults.iconButtonColors(),
            modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CHORD_LIBRARY_OPEN)
        ) {
            Icon(Icons.Default.MusicNote, contentDescription = "Show Chords")
        }
    }
}


@Composable
fun ActionMenuBottomBar(
    onMoveUp: () -> Unit,
    onMoveDown: () -> Unit,
    onDelete: () -> Unit,
    onCancel: () -> Unit,
    onAdd: () -> Unit,
    onDuplicate: () -> Unit
) {
    Surface(
        modifier = Modifier.fillMaxWidth().navigationBarsPadding(),
        shadowElevation = 8.dp,
        color = MaterialTheme.colorScheme.surfaceColorAtElevation(3.dp)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 4.dp, horizontal = 16.dp),
            horizontalArrangement = Arrangement.SpaceEvenly,
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButton(onClick = onMoveUp, modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_MOVE)) {
                Icon(Icons.Default.KeyboardArrowUp, contentDescription = "Move Up", modifier = Modifier.size(28.dp))
            }
            IconButton(onClick = onMoveDown, modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_MOVE, isSecondary = true)) {
                Icon(Icons.Default.KeyboardArrowDown, contentDescription = "Move Down", modifier = Modifier.size(28.dp))
            }
            IconButton(onClick = onAdd, modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_ADD)) {
                Icon(Icons.Default.Add, contentDescription = "Add Media", modifier = Modifier.size(28.dp))
            }
            IconButton(onClick = onDuplicate, modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_DUPLICATE_DELETE)) {
                Icon(Icons.Default.ContentCopy, contentDescription = "Duplicate", modifier = Modifier.size(24.dp))
            }
            IconButton(onClick = onDelete, modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_DUPLICATE_DELETE, isSecondary = true)) {
                Icon(Icons.Default.Delete, contentDescription = "Delete", tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(24.dp))
            }
            IconButton(onClick = onCancel) {
                Icon(Icons.Default.Close, contentDescription = "Cancel", modifier = Modifier.size(24.dp))
            }
        }
    }
}

@OptIn(androidx.compose.material3.ExperimentalMaterial3Api::class)
@Composable
fun ChordManagementBar(
    chords: List<ChordInLine>,
    activeChord: ChordInLine?,
    validInsertionPoints: List<Int>,
    onChordClick: (ChordInLine) -> Unit,
    onSliderChange: (Int) -> Unit,
    onSliderRelease: () -> Unit,
    onDeleteActiveChord: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colorScheme.surfaceColorAtElevation(3.dp))
            .padding(vertical = 4.dp, horizontal = 12.dp)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth()
        ) {
            LazyRow(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier.weight(1f).tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_CHORDS)
            ) {
                items(chords, key = { it.index }) { chord ->
                    Button(
                        onClick = { onChordClick(chord) },
                        shape = RoundedCornerShape(6.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = if (activeChord?.index == chord.index) GoldAccent else MaterialTheme.colorScheme.secondaryContainer,
                            contentColor = if (activeChord?.index == chord.index) Color.Black else MaterialTheme.colorScheme.onSecondaryContainer
                        ),
                        contentPadding = PaddingValues(horizontal = 12.dp, vertical = 4.dp)
                    ) {
                        Text(chord.name, fontFamily = FontFamily.Monospace, fontWeight = FontWeight.Bold)
                    }
                }
            }
            AnimatedVisibility(visible = activeChord != null) {
                IconButton(
                    onClick = onDeleteActiveChord,
                    modifier = Modifier.padding(start = 8.dp).size(24.dp)
                ) {
                    Icon(Icons.Default.Delete, contentDescription = "Delete Chord", tint = MaterialTheme.colorScheme.error)
                }
            }
        }
        AnimatedVisibility(visible = activeChord != null) {
            if (validInsertionPoints.isNotEmpty()) {
                var isDraggingLocal by remember { mutableStateOf(false) }
                val coroutineScope = rememberCoroutineScope()

                var localSliderPosition by remember { 
                    mutableStateOf(validInsertionPoints.indexOf(activeChord?.range?.first).coerceAtLeast(0).toFloat()) 
                }

                // Sync local state if external state changes, BUT ONLY if the user isn't currently dragging it
                // This prevents asynchronous recomposition updates from yanking the slider back to a stale position
                LaunchedEffect(activeChord, validInsertionPoints, isDraggingLocal) {
                    if (!isDraggingLocal) {
                        localSliderPosition = validInsertionPoints.indexOf(activeChord?.range?.first).coerceAtLeast(0).toFloat()
                    }
                }

                Slider(
                    value = localSliderPosition,
                    onValueChange = { newSliderIndex ->
                        isDraggingLocal = true
                        localSliderPosition = newSliderIndex
                        val newCharacterPosition = validInsertionPoints.getOrElse(kotlin.math.round(newSliderIndex).toInt()) { 0 }
                        onSliderChange(newCharacterPosition)
                    },
                    onValueChangeFinished = {
                        onSliderRelease()
                        coroutineScope.launch {
                            // Debounce the release by 500ms to allow the asynchronous UI state to catch up
                            // and to prevent hardware touch micro-lifts from yanking the slider back
                            delay(500)
                            isDraggingLocal = false
                        }
                    },
                    valueRange = 0f..(validInsertionPoints.size - 1).coerceAtLeast(0).toFloat(),
                    steps = if (validInsertionPoints.size > 1) validInsertionPoints.size - 2 else 0,
                    modifier = Modifier.padding(horizontal = 4.dp),
                    colors = SliderDefaults.colors(
                        thumbColor = SliderThumbGray,
                        activeTrackColor = SliderTrackGray,
                        inactiveTrackColor = SliderTrackGray
                    ),
                    thumb = {
                        SliderDefaults.Thumb(
                            interactionSource = remember { MutableInteractionSource() },
                            thumbSize = DpSize(12.dp, 12.dp),
                            colors = SliderDefaults.colors(
                                thumbColor = SliderThumbGray,
                                activeTrackColor = SliderTrackGray,
                                inactiveTrackColor = SliderTrackGray
                            )
                        )
                    }
                )
            }
        }
    }
}


